export default __webpack_public_path__ + "static/media/art.1f41c06f.jpeg";